import { CardContent, TableBody, TableCell, Typography } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import DeleteIcon from "@material-ui/icons/Delete";
import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import EmailIcon from "@material-ui/icons/Email";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import AddIcon from "@material-ui/icons/Add";
import { _get, _post } from "../../../Api";
import { toast } from "react-toastify";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function CloudAccounts(props) {
  const [cloudUsers, setCloudUsers] = React.useState(null);
  const [oldCloudUsers, setOldCloudUsers] = React.useState(null);
  const merchantId = props.merchant.id;
  const setAddAccountDialogType = props.setAddAccountType;
  const setRemoveAccountDialogType = props.setRemoveAccountType;
  const setSelectedAccount = props.setSelectedAccount;
  const setSendEmailDialog = props.setSendEmailDialog;

  function gatherCloudUsers(users) {
    const map = new Map();
    users.forEach((user) => {
      map.set(user.email, {
        email: user.email,
        cloudUserId: user.id,
        password: "",
      });
    });
    return map;
  }

  useEffect(() => {
    function getCloudUsers() {
      _get("/nova/merchant/" + merchantId + "/cloudaccount")
        .then((response) => {
          setCloudUsers(gatherCloudUsers(response.data));
          setOldCloudUsers(gatherCloudUsers(response.data));
        })
        .catch((e) => {
          console.log(e);
        });
    }

    getCloudUsers();
  }, [merchantId]);

  function updateCloudState(response) {
    if (response.data) {
      const user = response.data;
      cloudUsers.set(user.email, {
        email: user.email,
        password: "",
        cloudUserId: user.id,
      });
      oldCloudUsers.set(user.email, {
        email: user.email,
        cloudUserId: user.id,
        password: "",
      });
    } else {
      const user = response;
      cloudUsers.set(user.email, {
        email: user.email,
        cloudUserId: user.cloudUserId,
        password: user.password,
      });
    }
    const map = new Map();
    cloudUsers.forEach((cloudUser, email) => {
      map.set(email, cloudUser);
    });
    setCloudUsers(map);
  }

  function changePassword(event, cloudUserId) {
    const text = event.target.value;
    if (!!text === false) {
      toast.error("Password was not changed.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    _post("/nova/merchant/" + merchantId + "/cloudaccount/" + cloudUserId, {
      password: event.target.value,
    })
      .then((response) => {
        toast.success("Password changed successfully!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        updateCloudState(response);
      })
      .catch((e) => {
        toast.error("Password could not be changed.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(e);
        return Promise.reject();
      });
  }

  function removeUser(handheldUser) {
    setSelectedAccount(handheldUser);
    setRemoveAccountDialogType("cloud");
  }

  function sendEmail(account) {
    setSelectedAccount(account);
    setSendEmailDialog(true);
  }

  if (!cloudUsers) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Grid container direction={"column"}>
      <Grid container direction={"row"}>
        <Grid item lg={6}>
          <Typography variant={"h4"}>Cloud</Typography>
        </Grid>
        <Grid item lg={6}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setAddAccountDialogType("cloud")}
          >
            Account
          </Button>
        </Grid>
      </Grid>
      <Divider style={{ marginBottom: "20px" }} />
      <Grid container direction={"column"} spacing={4}>
        {[...cloudUsers.keys()].map((email) => {
          return (
            <Grid item key={email}>
              <Card>
                <CardContent>
                  <Table>
                    <TableBody>
                      <TableRow style={{ display: "flex", flexDirection: "row" }}>
                        <TableCell>
                          <Typography style={{ margin: "1em" }} variant={"h5"}>
                            {email}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={{ display: "flex", flexDirection: "row" }}>
                          <Paper style={{ padding: "1em" }} variant="outlined">
                            <TextField
                              label="password"
                              value={cloudUsers.get(email).password}
                              onChange={(event) => {
                                updateCloudState({
                                  email: email,
                                  password: event.target.value,
                                  cloudUserId: cloudUsers.get(email).cloudUserId,
                                });
                              }}
                              onBlur={(event) => {
                                if (cloudUsers.get(email).password.length > 0) {
                                  changePassword(event, cloudUsers.get(email).cloudUserId);
                                }
                              }}
                            />
                          </Paper>
                          <Button
                            style={{ margin: "1em" }}
                            startIcon={<EmailIcon />}
                            onClick={() => sendEmail(cloudUsers.get(email))}
                          />
                          <Button
                            style={{ margin: "1em" }}
                            startIcon={<DeleteIcon />}
                            onClick={() => removeUser(cloudUsers.get(email))}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
}
